import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react"
import find from "lodash/find"
import isEqual from "lodash/isEqual"
import PropTypes from "prop-types"
import { css } from "@emotion/react"
import StoreContext from "libs/context/StoreContext"
import { useDispatch } from "react-redux"
import { OverlayOpen } from "libs/redux/action"
import * as Atoms from "../atoms"
import { TimelineMax, Power2 } from "gsap"
import * as Transition from "../Transition"
import * as Libs from "libs"
import Img from "gatsby-image"
const ProductForm = ({ product, productInfo, productAvailable, ...rest }) => {
  const dispatch = useDispatch()
  const container = useRef()
  const inner = useRef()
  const { variants } = product
  let initialVariantId = 0
  let selectedOptionsList
  variants.some(function(variant, index) {
    const avalable = variant.availableForSale
    if (avalable) {
      initialVariantId = index
      return true
    } else {
      return false
    }
  })

  selectedOptionsList = variants.map(function(variant, index) {
    const option = variant.selectedOptions[0]
    return {
      value: option.value,
      name: option.name,
      availableForSale: variant.availableForSale,
    }
  })

  /*selectedOptionsList = []
  options.map(({ id, name, values }, index) => {
    selectedOptionsList = values.map(value => ({
      value: value,
      name: "SIZE",
      availability: false,
    }))
  })*/

  let [variant, setVariant] = useState({ ...variants[initialVariantId] })

  const [quantity] = useState(1)

  const {
    addVariantToCart,

    store: { client, adding },
  } = useContext(StoreContext)

  const productVariant =
    client.product.helpers.variantForOptions(product, variant) || variant
  const [available, setAvailable] = useState(productVariant.availableForSale)

  const checkAvailability = useCallback(
    productId => {
      client.product.fetch(productId).then(fetchedProduct => {
        // this checks the currently selected variant for availability
        const result = fetchedProduct.variants.filter(
          variant => variant.id === productVariant.shopifyId
        )

        if (result.length > 0) {
          setAvailable(result[0].available)
        }
      })
    },
    [client.product, productVariant.shopifyId]
  )

  useEffect(() => {
    checkAvailability(product.shopifyId)
  }, [productVariant, checkAvailability, product.shopifyId])
  useEffect(() => {
    const tl = new TimelineMax()
    const containerObj = container.current
    const innerObj = inner.current

    let h
    if (Libs.Common.Func.getDeviceSize() === "lessPab") {
      h = "80vh"
    } else {
      h = "100vh"
    }
    tl.set(containerObj, { height: "40vh" })
    tl.set(innerObj, { opacity: 0 })
    tl.to(containerObj, 0.5, {
      height: h,
      ease: Power2.easeOut,
    }).to(innerObj, 0.5, { opacity: 1, ease: Power2.easeOut })
  }, [])

  const handleOptionChange = selected => {
    const { value } = selected
    const currentOptions = [...variant.selectedOptions]

    currentOptions[0] = {
      ...currentOptions[0],
      value,
    }

    const selectedVariant = find(variants, ({ selectedOptions }) => {
      return isEqual(currentOptions, selectedOptions)
    })

    setAvailable(selectedVariant.availableForSale)
    setVariant({ ...selectedVariant })
  }

  const handleAddToCart = () => {
    addVariantToCart(productVariant.shopifyId, quantity)

    dispatch(OverlayOpen({ element: Libs.Store.Bag }))
  }

  /*
  Using this in conjunction with a select input for variants
  can cause a bug where the buy button is disabled, this
  happens when only one variant is available and it's not the
  first one in the dropdown list. I didn't feel like putting
  in time to fix this since its an edge case and most people
  wouldn't want to use dropdown styled selector anyways -
  at least if the have a sense for good design lol.
  */

  const price = Libs.Common.StoreFunc.getPrice(variant.presentmentPrices.edges)
  const contCss = props => {
    return css`
      position: absolute;
      z-index: 1000;

      background-color: #fff;

      transform: translateX(-50%);
      left: 50%;
      overflow-y: scroll;
      ${Libs.Styles.Mq.moreTab} {
        width: 33vw;
        min-width: 520px;
        height: 100vh;
        padding: 5.88235rem 2.94118rem 2.10084rem;
      }
      ${Libs.Styles.Mq.lessPab} {
        width: 100vw;
        height: 80vh;
        padding: 10vw 6vw 20vh 6vw;
        border-radius: 20px 20px 0 0;
        bottom: 0px;
      }
    `
  }
  const variantContCss = props => {
    return css`
      ${Libs.Common.Func.getPcSpVwValue("margin-top", 30, 30)};
      display: flex;
    `
  }
  const variantColorItemCss = color => {
    return css`
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: ${color};
      margin-left: 3px;
      margin-right: 9px;
      &.white {
        border: 2.5px solid #fff;
        box-shadow: 0 0 0 1px #ccc;
      }
      &.active {
        box-shadow: 0 0 0 1px #252525;
        border: 2.5px solid #fff;
      }

      &:last-child {
        margin-right: 0px;
      }
    `
  }
  const variantTumbnailItemCss = color => {
    return css`
      width: 80px;

      margin-left: 3px;
      margin-right: 9px;
      &.active {
        box-shadow: 0 0 0 1px #252525;
        border: 2.5px solid #fff;
      }
      &:last-child {
        margin-right: 0px;
      }
    `
  }
  const selectContCss = props => {
    return css`
      ${Libs.Common.Func.getPcSpVwValue("margin-top", 30, 30)};
    `
  }
  const toggleCss = props => {
    return css`
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;
      &:after {
        display: block;
        content: "";
        width: 23%;
      }
    `
  }
  const buttonCss = props => {
    return css`
      ${Libs.Styles.Mq.moreTab} {
        button {
          width: 100%;
        }
      }
      ${Libs.Styles.Mq.lessPab} {
        button {
          width: 88vw;
        }
      }
      ${Libs.Common.Func.getPcSpVwValue("margin-top", 30, 30)};
      ${Libs.Common.Func.getPcSpVwValue("margin-bottom", 30, 30)};
      width: 100%;
    `
  }

  const getOptions = options => {
    if (options) {
      return options.map(option => {
        return getOption(option)
      })
    } else {
      return null
    }
  }
  const getOption = option => {
    if (
      option === "size-guide-long-sleeve-tee" ||
      option === "size-guide-short-sleeve-tee"
    ) {
      return <Atoms.Chart option={option} />
    }
  }

  return (
    <div css={contCss} ref={container} {...rest}>
      <div ref={inner}>
        <Libs.Atoms.H1
          styles={{
            fontPc: { fontSize: 48, lineHeight: 48 },
            fontSp: { fontSize: 32, lineHeight: 32 },
          }}
        >
          {productInfo.name}
        </Libs.Atoms.H1>
        <Libs.Atoms.P
          styles={{
            fontPc: { fontSize: 36, lineHeight: 36 },
            spacePc: "18 0 0 0",
            fontSp: { fontSize: 28, lineHeight: 28 },
            spaceSp: "18 0 0 0",
          }}
        >
          {price}
        </Libs.Atoms.P>
        {productInfo.variantReferenceType ? (
          productInfo.variantReferenceType === "Variant Color" ? (
            <div css={variantContCss}>
              <div
                className={"active"}
                css={[variantColorItemCss(productInfo.variantColor)]}
              ></div>
              {productInfo.variantReference.map(item => (
                <Libs.Atoms.TriggerLink
                  onClick={function(event) {
                    Transition.TrigerSlideTransition.TrigerSlideTransition(
                      `/${productInfo.node_locale}/shop/${item.slug}`,
                      "",
                      dispatch
                    )
                    return false
                  }}
                >
                  <div
                    className={
                      !item.variantColor.startsWith("#")
                        ? item.variantColor
                        : ""
                    }
                    css={[variantColorItemCss(item.variantColor)]}
                  ></div>
                </Libs.Atoms.TriggerLink>
              ))}
            </div>
          ) : productInfo.variantReferenceType === "Thumbnail" ? (
            <div css={variantContCss}>
              <div className={"active"} css={variantTumbnailItemCss}>
                <Img
                  fluid={productInfo.thumbnail.fluid}
                  alt={productInfo.thumbnail.title}
                />
              </div>
              {productInfo.variantReference.map(item => (
                <Libs.Atoms.TriggerLink
                  onClick={function(event) {
                    Transition.TrigerSlideTransition.TrigerSlideTransition(
                      `/${productInfo.node_locale}/shop/${item.slug}`,
                      "",
                      dispatch
                    )
                    return false
                  }}
                >
                  <div css={variantTumbnailItemCss}>
                    <Img
                      fluid={item.thumbnail.fluid}
                      alt={item.thumbnail.title}
                    />
                  </div>
                </Libs.Atoms.TriggerLink>
              ))}
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <div css={selectContCss}>
          <React.Fragment>
            {/*<label htmlFor={name}>{name} </label>*/}
            {selectedOptionsList.length > 1 && (
              <Atoms.Toggles
                css={toggleCss}
                options={selectedOptionsList}
                onChange={handleOptionChange}
                defaultValue={selectedOptionsList[initialVariantId]}
              />
            )}
            {/*<Libs.Atoms.Select
                css={selectCss}
                options={selectedOptionsList}
                onChange={handleOptionChange(index)}
                defaultValue={selectedOptionsList[initialVariantId]}
              />*/}
          </React.Fragment>

          {/*<React.Fragment key={"quantity"}>
          <Atoms.Select
            css={selectQuantityCss}
            options={quantityOptions}
            onChange={handleQuantityChange}
            defaultValue={quantityOptions[0]}
          />
        </React.Fragment> */}
        </div>
        <Libs.Atoms.ButtonElement
          css={buttonCss}
          disabled={!available || !productAvailable || adding}
          onClick={handleAddToCart}
          spanStyles={{
            fontPc: {
              fontSize: 20,
              fontFace: "sansserif",
              bold: true,
              letterSpacing: ".5",
            },
            fontSp: {
              fontSize: 20,
              fontFace: "sansserif",
              bold: true,
              letterSpacing: ".5",
            },
          }}
        >
          {!available || !productAvailable ? "SOLD OUT" : "Add To Cart"}
        </Libs.Atoms.ButtonElement>

        <Libs.Atoms.RichText
          styles={
            productInfo.node_locale === "en"
              ? {
                  fontPc: {
                    fontSize: 18,
                    fontFace: "sansserif",
                    lineHeight: "30",
                  },
                  fontSp: {
                    fontSize: 16,
                    fontFace: "sansserif",
                    lineHeight: "28",
                  },
                }
              : {
                  fontPc: {
                    fontSize: 16,
                    fontFace: "sansserif",
                    lineHeight: "30",
                  },
                  fontSp: {
                    fontSize: 15,
                    fontFace: "sansserif",
                    lineHeight: "27",
                  },
                }
          }
        >
          {productInfo.productDescription}
        </Libs.Atoms.RichText>
        {getOptions(productInfo.options)}
      </div>
    </div>
  )
}

ProductForm.propTypes = {
  product: PropTypes.shape({
    descriptionHtml: PropTypes.string,
    handle: PropTypes.string,
    id: PropTypes.string,
    shopifyId: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        originalSrc: PropTypes.string,
      })
    ),
    vendor: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string),
      })
    ),
    productType: PropTypes.string,
    title: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        availableForSale: PropTypes.bool,
        id: PropTypes.string,
        price: PropTypes.string,
        title: PropTypes.string,
        shopifyId: PropTypes.string,
        selectedOptions: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
          })
        ),
      })
    ),
  }),
  addVariantToCart: PropTypes.func,
}

export default ProductForm
